export default __webpack_public_path__ + "images/489a061d8121a485126b994167f4e446-dont_3.png";